import React from 'react';
import {
  Typography as MuiTypography,
  TypographyProps as MuiTypographyProps
} from '@mui/material';

export type TypographyProps = Omit<
  MuiTypographyProps,
  'variant' | 'weight' | 'component'
> & {
  variant?:
    | 'h1'
    | 'h2'
    | 'h3'
    | 'h4'
    | 'h5'
    | 'h6'
    | 'title'
    | 'subtitle'
    | 'button'
    | 'body1'
    | 'body2'
    | 'body3'
    | 'body4'
    | 'body5';
  weight?: 'bolder' | 'bold' | 'normal' | 'lighter';
  component?: React.ElementType;
};

const fontWeight = {
  bolder: '700',
  bold: '600',
  normal: '400',
  lighter: '300'
};

/**
 * Use typography to present your design and content as clearly and efficiently as possible.
 *
 * This is a custom wrapper component made of Material-UI Typography.
 *
 * You can read Material-UI Typography Documentation [here](https://mui.com/material-ui/api/typography/).
 *
 * ```typescript
 *  import { Typography } from '@rabex-kit/core';
 *  ```
 *
 *
 * @param props
 * @returns
 */

const Typography: React.FC<TypographyProps> = ({ weight, sx, ...props }) => {
  return (
    <MuiTypography
      sx={{
        ...sx,
        fontWeight: weight ? fontWeight[weight] : 'normal'
      }}
      {...props}
    />
  );
};

Typography.defaultProps = {
  variant: 'body1',
  weight: 'normal'
};

export default Typography;
